import React, { useEffect, useState } from 'react';
import Draggable from 'react-draggable';
import { Resizable } from 'react-resizable';
import { toast } from 'react-toastify';
import Button from '../../common/buttons/Button';
import { removeFuncBtnGroupHandler } from '../../../helpers/h-funcBtnMng';
import {
  closeAllFuncBtnModal,
  closeFuncBtnGroupMainModal,
  openFuncBtnGroupAddModal,
  openFuncBtnGroupModifyModal,
} from '../../../helpers/h-modals';
import { ResizeCallbackData } from '../../../interfaces/I-modals';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import FuncBtnGroupList_Table from '../../tables/funcBtnMng/FuncBtnGroupList_Table';

interface Props {
  onClickClose?: () => void;
}

const FuncBtnGroupMngModal = (props: Props) => {
  const { selectedFuncBtnGroupModal } = useAppSelector(
    (state) => state.funcButtonManagement,
  );

  const [size, setSize] = useState({
    width: 600,
    height: 600,
  });

  const onResize = (
    e: React.SyntheticEvent<Element, Event>,
    data: ResizeCallbackData,
  ) => {
    setSize({
      width: data.size.width,
      height: data.size.height,
    });
  };

  // FUNC 버튼 그룹 수정 모달 핸들러
  const handleModifyFuncBtnGroup = () => {
    if (selectedFuncBtnGroupModal === null)
      return toast.error('버튼 그룹을 선택해주세요.');
    openFuncBtnGroupModifyModal();
  };

  // FUNC 버튼 그룹 삭제 핸들러
  const handleRemoveFuncBtnGroup = () => {
    removeFuncBtnGroupHandler(selectedFuncBtnGroupModal);
  };

  // 클리어 함수
  useEffect(() => {
    return () => {
      closeAllFuncBtnModal();
    };
  }, []);

  return (
    <Draggable handle="#handle">
      <Resizable
        handle={
          <div
            className="resizable-custom-handler absolute"
            style={{
              left: size.width - 19,
              top: size.height - 19,
            }}
          ></div>
        }
        height={size.height}
        width={size.width}
        onResize={onResize}
      >
        <div className="modal-wrapper">
          {/* WRAPPER */}
          <div
            className="box drag-box  flex flex-col px-[1.25rem]
            relative border border-modal-subTitle bg-white z-50 shadow-listbox-options
            rounded
          "
            style={{ width: `${size.width}px`, height: `${size.height}px` }}
          >
            {/* HEADER */}
            <div
              id="handle"
              className="min-h-[3.5rem] cursor-move w-full flex flex-col relative"
            >
              <div className="grow font-bold w-full flex items-center truncate">
                버튼 그룹 관리
              </div>
            </div>
            {/* BODY */}
            <div className="grow w-full flex flex-col gap-3 overflow-y-auto">
              {/* 버튼 */}
              <div className="flex gap-1 my-1">
                <Button
                  kind="cancel"
                  label="버튼 그룹 추가"
                  onClick={openFuncBtnGroupAddModal}
                />
                <Button
                  kind="cancel"
                  label="버튼 그룹 수정"
                  onClick={handleModifyFuncBtnGroup}
                />
                <Button
                  kind="cancel"
                  label="버튼 그룹 삭제"
                  onClick={handleRemoveFuncBtnGroup}
                />
              </div>
              <FuncBtnGroupList_Table />
              {/* 테이블 */}
            </div>
            {/* FOOTER */}
            <div className="min-h-[6rem] w-full  jcac">
              <Button
                onClick={closeFuncBtnGroupMainModal}
                kind="primary"
                label="확인"
              />
            </div>
            {/* 닫기 버튼 */}
            <button
              onClick={closeFuncBtnGroupMainModal}
              className="absolute right-1 top-1"
            >
              X
            </button>
          </div>
        </div>
      </Resizable>
    </Draggable>
  );
};

export default FuncBtnGroupMngModal;
